import script from "./companyVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./companyVideo.vue?vue&type=script&setup=true&lang=js"

import "./companyVideo.vue?vue&type=style&index=0&id=27e6e15c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27e6e15c"]])

export default __exports__